__turbopack_context__.v({
  "eyebrow": "k1-ksW_eyebrow",
});
